import { observer } from "mobx-react";
import { Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import WhiteCardTitle from "../typographies/WhiteCardTitle";
import WhiteCardInfo from "../typographies/WhiteCardInfo";
import SummaryFrame from "./details/SummaryFrame";
import SummaryContent from "./details/SummaryContent";
import { useStoreContext } from "../..";
import { useEffect } from "react";

const EQ5DLSummary = observer(() => {
  const { eQ5D5LStore, formStore } = useStoreContext();

  useEffect(() => {
    if (formStore.forms && !eQ5D5LStore.eQ5D5Ls) {
      eQ5D5LStore.get5Q5DLs();
    }
  }, [formStore.forms, eQ5D5LStore.eQ5D5Ls]);

  const currentScore = eQ5D5LStore.eQ5D5Ls && eQ5D5LStore.currentScore;

  return (
    <SummaryFrame>
      <Box className="flex-row-center-start">
        <PersonIcon sx={{ color: "white", marginRight: "4px" }} />
        <WhiteCardTitle text="EQ-5D-5L" />
      </Box>
      <SummaryContent>
        <WhiteCardInfo text="Uppskattat hälsotillstånd på en skala från 1 till 100, där 100 är högst." />
        <Box className="flex-row-center-center">
          {currentScore && (
            <WhiteCardInfo text={`${currentScore}`} fontSize={100} />
          )}
        </Box>
      </SummaryContent>
    </SummaryFrame>
  );
});

export default EQ5DLSummary;
